import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-baggage-timer',
  templateUrl: './baggage-timer.component.html',
  styleUrls: ['./baggage-timer.component.scss'], 
  standalone: false,
})
export class BaggageTimerComponent {
  @Input() hourBaggageDrop: number = 0;
  @Input() minutesBaggageDrop: number = 0;
}